import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import { FaHome } from 'react-icons/fa'
import { publishEvent } from '../../utils'

export default function HomeButton() {
  console.log('HomeButton rendered')

  function clicked() {
    console.log('HomeButton: clicked')
    publishEvent('SIDEBAR', { className: 'sidebar-not-collapsed' }, 'HomeButton: clicked')
  }

  return (
    <Link to="/home" data-cy="navbar-home-link" onClick={clicked}>
      <Button color="primary" className="navbar-home-button" data-cy="navbar-home-button">
        <FaHome style={{ width: '1.25rem', height: '1.25rem' }} />
      </Button>
    </Link>
  )
}
